import LoginPage from "views/Pages/LoginPage.jsx";
import RegisterPage from "views/Pages/RegisterPage.jsx";
import LockScreenPage from "views/Pages/LockScreenPage.jsx";
import ResetPasswordPage from "views/Pages/ResetPasswordPage.jsx";
import ForgotPasswordPage from "views/Pages/ForgotPasswordPage.jsx";

var pagesRoutes = [
  {
    path: "/pages/login-page",
    name: "Login Page",
    mini: "LP",
    component: LoginPage,
    needAuth: false
  },
  {
    path: "/pages/register-page",
    name: "Register",
    mini: "RP",
    component: RegisterPage,
    needAuth: false
  },
  {
    path: "/pages/lock-screen-page",
    name: "Lock Screen Page",
    mini: "LSP",
    component: LockScreenPage,
    needAuth: false
  },
  {
    path: "/pages/reset-password",
    name: "Reset Password",
    mini: "RP",
    component: ResetPasswordPage,
    needAuth: false
  },
  {
    path: "/pages/forgot-password",
    name: "Forgot Password",
    mini: "FP",
    component: ForgotPasswordPage,
    needAuth: false
  }
];

export default pagesRoutes;




// WEBPACK FOOTER //
// ./src/routes/pages.jsx